import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button } from "@air/primitive-button";
import { Modal, ModalDescription, ModalTitle } from "@air/primitive-modal";
import { useToasts } from "@air/provider-toast";
import pluralize from "pluralize";
import { ToastLink } from "~/components/UI/ToastLink";
import { useGoToBoardPage } from "~/hooks/useGoToBoardPage";
import { useMoveItems } from "~/hooks/useMoveItems";
import { useAddAssetsToBoards } from "~/swr-hooks/boards/useAddAssetsToBoards";
export const MoveItemsConfirmationModal = (param)=>{
    let { boards, clips, selectedBoard, selectedLibrary, onClose } = param;
    const { showToast } = useToasts();
    const { goToBoardPage } = useGoToBoardPage();
    const addAssetsToBoardMutation = useAddAssetsToBoards();
    const { moveItems } = useMoveItems({
        boards,
        clips,
        trackLocation: "move-items-confirmation-modal"
    });
    return /*#__PURE__*/ _jsxs(Modal, {
        className: "flex flex-col gap-6",
        dangerouslyBypassFocusLock: true,
        isOpen: true,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ _jsx(ModalTitle, {
                        children: "Delete comments?"
                    }),
                    /*#__PURE__*/ _jsx(ModalDescription, {
                        children: "There are comments on this asset in the current board, and moving it will delete them. To keep these comments, consider adding the asset to another board instead."
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("footer", {
                className: "flex items-center justify-end gap-2",
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        appearance: "ghost",
                        color: "grey",
                        onClick: onClose,
                        size: "large",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex gap-2",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                appearance: "outline",
                                color: "grey",
                                disabled: !selectedBoard,
                                isLoading: addAssetsToBoardMutation.isPending,
                                onClick: ()=>{
                                    if (selectedBoard) {
                                        addAssetsToBoardMutation.mutate({
                                            clipIds: (clips === null || clips === void 0 ? void 0 : clips.map((clip)=>clip.id)) || [],
                                            boards: [
                                                selectedBoard
                                            ],
                                            trackLocation: "move-items-confirmation-modal"
                                        }, {
                                            onSuccess: (_data, param)=>{
                                                let { clipIds, boards } = param;
                                                showToast(/*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        "".concat(pluralize("item", clipIds.length, true), " added to "),
                                                        boards.length === 1 ? /*#__PURE__*/ _jsx(ToastLink, {
                                                            onClick: ()=>goToBoardPage({
                                                                    board: boards[0],
                                                                    trackLocation: "add-clips-to-board-toast"
                                                                }),
                                                            children: boards[0].title
                                                        }) : /*#__PURE__*/ _jsx(_Fragment, {
                                                            children: "multiple boards"
                                                        })
                                                    ]
                                                }));
                                                onClose === null || onClose === void 0 ? void 0 : onClose();
                                            }
                                        });
                                    }
                                },
                                size: "large",
                                children: "Add instead"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                appearance: "filled",
                                color: "red",
                                isLoading: moveItems.isPending,
                                onClick: ()=>moveItems.mutate({
                                        selectedBoard,
                                        selectedLibrary
                                    }, {
                                        onSuccess: ()=>{
                                            onClose === null || onClose === void 0 ? void 0 : onClose();
                                        }
                                    }),
                                size: "large",
                                children: "Delete and move"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
